<template>
  <div class="container print-family-resident-release">
    <b-overlay :show="loading" opacity="0.99">
      <ErrorsMessages :errors="errors" />
      <div v-show="errors.length == 0">
        <div class="content-btn-print d-flex justify-content-end mb-2">
          <v-btn class="btn-print" v-on:click="printOut"
            ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
          >
        </div>
        <table v-if="data" class="bg-white">
          <thead>
            <div class="row">
              <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 pt-1 pb-0">
                <img
                  v-if="rest_home_logo_url"
                  class="rest_home_logo_url"
                  :src="rest_home_logo_url"
                />
                <div v-if="!rest_home_logo_url" class="ml-1">
                  <strong class="text-uppercase">{{ rest_home_name }}</strong>
                </div>
              </div>
              <div class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7 pt-1 pb-0">
                <div class="row">
                  <img
                    v-if="data.resident_photo_url"
                    class="resident_photo_url"
                    :src="data.resident_photo_url"
                  />
                  <img
                    v-if="!data.resident_photo_url"
                    class="resident_photo_url"
                    :src="require('../../../../../assets/user.png')"
                  />
                  <div class="ml-5 mt-2">
                    <h6 class="mb-0">
                      {{ data.resident_name }}
                    </h6>
                    <h6 class="mb-0 worksansr upper-text">
                      Data de nascimento:
                      {{ formatDate(data.resident_date_of_birth, false) }}
                      -
                      {{ getAge(data.resident_date_of_birth) }}
                      anos
                    </h6>
                    <h6 class="mb-0 worksansr upper-text">
                      Data de admissão:
                      {{ formatDate(data.resident_date_of_reception, false) }}
                    </h6>
                  </div>
                </div>
              </div>
              <div
                class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 pt-1 pb-0 check-text-right"
              >
                <img class="logo" :src="logo" width="180" />
              </div>
            </div>
          </thead>
          <div>
            <div class="data-inside-avoid">
              <div class="text-center">
                <span class="text-muted">QUEM FEZ?:</span>
                <strong class="ml-2"
                  >{{
                    professionalClassCouncilValue({
                      id: data.user_professional_class_council_id,
                      name: data.user_name,
                      profile: data.user_profile_name,
                      office: data.user_office,
                      cpf: data.user_cpf,
                      value: data.user_professional_class_council_value,
                    })
                  }}
                </strong>
                <span class="text-muted">DATA:</span>
                <strong class="ml-2">{{
                  moment(data.created_at).format("DD/MM/YYYY HH:mm:ss")
                }}</strong>
              </div>
              <div
                class="mt-1 mb-1 data-inside-avoid"
                v-for="(resident_account_item, key) in data.items.data"
                :key="key"
              >
                <div class="row m-0 data-inside-avoid">
                  <div class="col-md-3 pt-0 pb-0 d-flex align-items-center">
                    <span class="text-muted">TIPO:</span>
                    <strong class="ml-2">{{
                      handleType(resident_account_item.type)
                    }}</strong>
                  </div>
                  <div class="col-md-3 pt-0 pb-0 d-flex align-items-center">
                    <div v-if="resident_account_item.type == 'SERVICE'">
                      <span class="text-muted">QUANTIDADE:</span>
                      <strong class="ml-2">{{
                        resident_account_item.quantity
                      }}</strong>
                    </div>
                    <div v-if="resident_account_item.type == 'STOCK_SALE'">
                      <span class="text-muted">QUANTIDADE:</span>
                      <strong class="ml-2"
                        >{{ resident_account_item.stock_sale_amount }}
                        {{
                          resident_account_item.stock_sale_stock_item_unit_of_measurement_abbreviation
                        }}
                      </strong>
                    </div>
                  </div>
                  <div class="col-md-3 pt-0 pb-0">
                    <span class="text-muted">VALOR:</span>
                    <strong class="ml-2">{{
                      formatReal(resident_account_item.value)
                    }}</strong>
                    <br />
                    <span class="text-muted">TOTAL:</span>
                    <strong class="ml-2">{{
                      formatReal(
                        parseInt(resident_account_item.quantity) *
                          parseFloat(resident_account_item.value)
                      )
                    }}</strong>
                  </div>
                  <div class="col-md-3 pt-0 pb-0 d-flex align-items-center">
                    <span class="text-muted">TOTAL FINAL:</span>
                    <strong class="ml-2">{{
                      formatReal(resident_account_item.total_value)
                    }}</strong>
                  </div>
                  <div
                    class="col-md-12"
                    v-if="resident_account_item.type == 'SERVICE'"
                  >
                    <span class="text-muted">INFORMAÇÕES DO SERVIÇO:</span>
                    <div>
                      <span class="text-muted">SERVIÇO:</span>
                      <strong class="ml-2"
                        >{{ resident_account_item.service_description }}
                      </strong>
                    </div>
                  </div>
                  <div
                    class="col-md-12"
                    v-if="resident_account_item.type == 'STOCK_SALE'"
                  >
                    <span class="text-muted">INFORMAÇÕES DA VENDA:</span>
                    <div>
                      <span class="text-muted">GRUPO:</span>
                      <strong class="ml-2"
                        >{{ resident_account_item.stock_sale_stock_group_name }}
                      </strong>
                    </div>
                    <div>
                      <span class="text-muted">MEDICAMENTO:</span>
                      <strong class="ml-2"
                        >{{ resident_account_item.stock_sale_medicine_name }}
                      </strong>
                    </div>
                    <div>
                      <span class="text-muted">LOTE:</span>
                      <strong class="ml-2">{{
                        resident_account_item.stock_sale_lot
                      }}</strong>
                    </div>
                    <div>
                      <span class="text-muted">DATA DE VENCIMENTO:</span>
                      <strong class="ml-2">{{
                        moment(
                          resident_account_item.stock_sale_due_date
                        ).format("MM/YYYY")
                      }}</strong>
                    </div>
                    <div v-if="resident_account_item.stock_sale_description">
                      <span class="text-muted">DESCRIÇÃO:</span>
                      <strong class="ml-2">{{
                        resident_account_item.stock_sale_description
                      }}</strong>
                    </div>
                  </div>
                </div>
                <hr />
              </div>
              <div class="row m-0 data-inside-avoid">
                <div class="col-md-3"></div>
                <div class="col-md-3"></div>
                <div class="col-md-3"></div>
                <div class="col-md-3">
                  <h1 class="title-pages">
                    <span class="text-muted">TOTAL:</span>
                    {{ formatReal(data.items.total) }}
                  </h1>
                </div>
              </div>
            </div>
            <div class="text-center">
              (Assinatura eletrônica)
              {{
                professionalClassCouncilValue({
                  id: user.professional_class_council_id,
                  name: user.name,
                  profile: user.profile_name,
                  cpf: user.cpf,
                  office: user.office,
                  value: user.professional_class_council_value,
                })
              }}
              <small> - {{ moment().format("DD/MM/YYYY HH:mm:ss") }} </small>
            </div>
          </div>
        </table>
        <div class="mt-2 content-btn-print d-flex justify-content-end">
          <v-btn class="btn-print" v-on:click="printOut"
            ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
          >
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../../../Components/ErrorsMessages";

import api from "../../../../../services/api";

import { getAge } from "../../../../../lib/getAgeByDate";

import {
  formatDate,
  formatReal,
  professionalClassCouncilValue,
} from "../../../../../lib/format";

import routes from "../../../../../routes";

import moment from "moment";

import { userData } from "../../../../../lib/functions";

export default {
  name: "FamilyResidentRelease",

  components: {
    ErrorsMessages,
  },

  data() {
    return {
      user: null,

      data: null,

      rest_home_name: "",
      rest_home_fantasy_name: "",
      rest_home_logo_url: null,
      logo: null,

      loading: true,

      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    moment,
    getAge,
    formatDate,
    formatReal,
    professionalClassCouncilValue,

    handleType(type) {
      return (
        {
          SERVICE: "SERVIÇO",
          STOCK_SALE: "VENDA DA EMPRESA",
        }[type] || "NÃO ENCONTRADO!"
      );
    },

    async retrieve() {
      try {
        const { id } = routes.history.current.params;

        if (!id) {
          this.errors = ["Lançamento não encontrado"];
          return;
        }

        const { user, logo } = userData();

        this.user = user;

        this.rest_home_name = user.rest_home_name;
        this.rest_home_fantasy_name = user.rest_home_fantasy_name;
        this.rest_home_logo_url = user.logo_url;
        this.logo = logo;

        this.loading = true;

        var params = { id };

        const response = await api.get(
          "/rest-home/family/releases/executed/print",
          {
            params,
          }
        );

        const { error, errors, data } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.data = data;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    printOut: () => window.print(),
  },
};
</script>

<style>
.print-family-resident-release table {
  width: 100%;
}

.print-family-resident-release .header {
  position: fixed;
  top: 0;
}

.print-family-resident-release .logo {
  height: 50px;
  object-fit: contain;
}

.print-family-resident-release .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}

.print-family-resident-release .resident_photo_url {
  height: 80px;
  width: 80px;
  border-radius: 50%;
  object-fit: cover;
}

@media print {
  .print-family-resident-release table {
    width: 100% !important;
  }

  .print-family-resident-release button {
    display: none;
  }

  .print-family-resident-release .content {
    page-break-inside: avoid !important;
  }

  .print-family-resident-release .data-inside-avoid {
    page-break-inside: avoid !important;
  }

  .print-family-resident-release .finish_user {
    font-size: small !important;
  }
}
</style>
